export default "__VITE_ASSET__D6uHE0Pq__"